import React from 'react';

import { Container } from './styles';

const Public = ({ children }) => {
  return <Container>{children}</Container>;
};

export default Public;
